import * as z from "zod";
import { OC } from "../../utils";
import { AdminAuth } from "./schema";

export const authContract = OC.router({
  signIn: {
    owner: {
      handler: OC.output(z.object({ url: z.string() })),
      callback: OC.meta({ noCsrf: true }).route({
        method: "GET",
        outputStructure: "detailed",
      }),
    },
    employee: OC.input(AdminAuth.UsernameSignIn),
  },
  signOut: OC.meta({ aragon: "sign_out" }),
  getAuth: OC.output(
    z
      .union([
        AdminAuth.AuthData.options[0].omit({ session: true }),
        AdminAuth.AuthData.options[1].omit({ session: true }),
      ])
      .nullable(),
  ),
});
